import { Injectable } from '@angular/core';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from 'projects/Autofacets-Core/src/app/utils/urls';

@Injectable({
  providedIn: 'root'
})
export class InvoiceDataService {

  constructor(private dataProvider: DataService) { }
  
  async getDocumentWarning(workOrderNo: string, languageCode: string): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetDocumentWarningByWo, workOrderNo, languageCode).toPromise();
  }
  async GenerateInvoice(InvoieGenerateModel: any): Promise<GenericResponse<any>> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GenerateInvoice, InvoieGenerateModel).toPromise();
  }
  async getPostedInvoiceByWo(appointmentId: number, workOrderNo: string): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetPostedInvoiceByWo, appointmentId, workOrderNo).toPromise();
  }
  async getInvoiceDocument(invoiceNo: string, languageCode: string): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetInvoiceDocuments, invoiceNo, languageCode).toPromise();
  }
  async getInvoicePreview(invoicePreviewRequestModel: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetInvoicePreview, invoicePreviewRequestModel).toPromise();
  }
}
